import { useRef, useEffect, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import classes from "./SearchInput.module.css";
import { SearchContext } from '../../../App';
import {
  isKnownActivitySuggestion,
  appendHomeSearchParams,
} from '../../../util/activitySearchOptions';

import searchIcon from "../../../public/HomepageVectors/2 Such-Icon.svg";
import arrow from "../../../public/HomepageVectors/3 Pfeil rechts.svg";

export const SearchInputs = () => {
  const navigate = useNavigate();
  const [isLocationHovered, setIsLocationHovered] = useState(false);
  const [isActivityHovered, setIsActivityHovered] = useState(false);
  const [isDateHovered, setIsDateHovered] = useState(false);
  const [isActivityInvalid, setIsActivityInvalid] = useState(false);

  const { 
    searchFields, 
    setSearchFields, 
    setActiveInput, 
    activeInput,
    updateSearchField,
    filteredActivities,
  } = useContext(SearchContext);
  
  const overlayRef = useRef(null);
  const inputRefs = {
    activity: useRef(null),
    location: useRef(null),
    date: useRef(null)
  };

  const handleArrowMouseEnter = () => {
    // Date input is commented out, so no hover effect needed
    return;
  };
  
  const handleArrowMouseLeave = () => {
    // Date input is commented out, so no hover effect needed
    return;
  };

  const handleLocationMouseEnter = (e) => {
    if (activeInput) return;
    setIsLocationHovered(true);
    handleMouseEnter('location', e);
  };

  const handleLocationMouseLeave = () => {
    setIsLocationHovered(false);
    handleMouseLeave();
  };

  
  const handleActivityMouseEnter = (e) => {
    if (activeInput) return;
    setIsActivityHovered(true);
    handleMouseEnter('activity', e);
  };

  const handleActivityMouseLeave = () => {
    setIsActivityHovered(false);
    handleMouseLeave();
  };

  const handleDateMouseEnter = (e) => {
    if (activeInput) return;
    setIsDateHovered(true);
    handleMouseEnter('date', e);
  };

  const handleDateMouseLeave = () => {
    setIsDateHovered(false);
    handleMouseLeave();
  };

  const handleFocus = (input, event) => {
    if (activeInput === input) return;
    setActiveInput(input);
    const overlay = overlayRef.current;
    const target = event.target.closest(`.${classes.inputGroup}`);
    const containerRect = target.closest(`.${classes.searchContainer}`).getBoundingClientRect();
    const inputGroupRect = target.getBoundingClientRect();

    let width = inputGroupRect.width + 3;
    let left = inputGroupRect.left - containerRect.left;

    if (input === 'date') {
      width += 47;
      left -= 7;
    }

    if (input === 'location') {
      // width += 2;
      // left -= 4;
      width += 47;
      left -= 7;
    }

    overlay.style.width = `${width}px`;
    overlay.style.height = `${containerRect.height}px`;
    overlay.style.transform = `translate(${left}px, 0)`;
    overlay.classList.add(classes.active);
  };

  const handleBlur = (input, event) => {
    if (input === 'activity' && !searchFields.activity) {
      setSearchFields((prevFields) => ({
        ...prevFields,
        activity: ''
      }));
    }
    if (input === 'location' && !searchFields.location) {
      setSearchFields((prevFields) => ({
        ...prevFields,
        location: ''
      }));
    }
    if (input === 'date') {
      event.target.type = 'text';
      if (!searchFields.date) {
        setSearchFields((prevFields) => ({
          ...prevFields,
          date: ''
        }));
      }
    }
  };  

  const handleLabelMouseDown = (e) => {
    e.preventDefault();
  };

  const handleClick = (input) => {
    const el = inputRefs[input].current;
    if (!el || document.activeElement === el) return;
    el.focus();
  };

  const handleClickOutside = (event) => {
    const isOutsideInputsContainer = !event.target.closest(`.${classes.inputsContainer}`);
    const isOutsideResultsContainer = !event.target.closest(".SearchOptions_resultsContainer__M6hDA");
    const isInsidePhoneSearch = event.target.closest('[data-phone-search-modal]');

    if (isOutsideInputsContainer && isOutsideResultsContainer && !isInsidePhoneSearch) {
      setActiveInput(null);
      const overlay = overlayRef.current;
      overlay.classList.remove(classes.active);
    }
  };

  const handleChange = (input, event) => {
    const value = event.target.value;
    setSearchFields((prevFields) => ({
      ...prevFields,
      [input]: value
    }));
    updateSearchField(input, value);

    // Check if activity is valid when activity input changes
    if (input === 'activity') {
      setIsActivityInvalid(!isKnownActivitySuggestion(value));
    }
  };
  
  const handleSearchResults = () => {
    // Check if the entered activity exists in filtered activities
    // If filteredActivities is empty, allow search (trust existing value)
    // If filteredActivities has items, validate against them
    if (searchFields.activity && !isKnownActivitySuggestion(searchFields.activity)) {
      return;
    }

    if (searchFields.activity || searchFields.location) {
      const queryParams = appendHomeSearchParams(new URLSearchParams(), {
        activity: searchFields.activity,
        location: searchFields.location,
        locationPlaceId: searchFields.locationPlaceId,
        date: searchFields.date,
      }).toString();
      setActiveInput(null);
      navigate(`/search?${queryParams}`, { replace: false });
    }
  };

  const handleMouseEnter = (input, event) => {
    if (activeInput) return;
    const overlay = overlayRef.current;
    let target;
    if (input === 'arrow') {
      target = document?.querySelector(`.${classes.dateInput}`);
      // If date input doesn't exist (commented out), return early
      if (!target) return;
    }else {
       target = event.target.closest(`.${classes.inputGroup}`);
    }
    
    // Add null checks for target and its closest container
    const container = target?.closest(`.${classes.searchContainer}`);
    if (!container) return;
    
    const containerRect = container.getBoundingClientRect();
    const inputGroupRect = target.getBoundingClientRect();

    let width = inputGroupRect.width + 3;
    let left = inputGroupRect?.left - containerRect?.left;

    // if (input === 'date' || input === 'arrow') {
    //   width += 47;
    //   left -= 7;
    // }

    if (input === 'location') {
      // width += 2;
      // left -= 4;
      width += 46;
      left -= 6;
    }

    overlay.style.width = `${width}px`;
    overlay.style.height = `${containerRect.height}px`;
    overlay.style.transform = `translate(${left}px, 0)`;
    overlay.classList.add(classes.active);
  };

  const handleMouseLeave = () => {
    if (activeInput) return;
    const overlay = overlayRef.current;
    overlay.classList.remove(classes.active);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div className={classes.inputsContainer}>
      <div className={classes.searchContainer}>
        <div 
          className={classes.inputGroup} 
          onClick={() => handleClick('activity')}
          onMouseEnter={handleActivityMouseEnter}
          onMouseLeave={handleActivityMouseLeave}
        >
          <div
            className={classes.searchIconContainer}
            onMouseDown={handleLabelMouseDown}
          >
            <img src={searchIcon} alt="Search Icon"/>
          </div>
          <div className={classes.searchText} style={{paddingLeft: "24.5px", paddingRight: "35px"}}>
            <span onMouseDown={handleLabelMouseDown}>Was?</span>
            <input
              type="text"
              placeholder="Aktivität oder Studio"
              className='semiboldSmall'
              ref={inputRefs.activity}
              onChange={(e) => handleChange('activity', e)}
              onFocus={(e) => handleFocus('activity', e)}
              onBlur={() => handleBlur('activity')}
              value={searchFields.activity}
            />
          </div>
        </div>
        <div 
          className={classes.inputGroup} 
          onClick={() => handleClick('location')}
          onMouseEnter={handleLocationMouseEnter}
          onMouseLeave={handleLocationMouseLeave}
        >
          <div 
            className={classes.smallLine}
            // style={{ display: isLocationHovered || isActivityHovered ? 'none' : 'block' }}
          ></div>
          <div className={classes.searchText}>
            <span 
              className={classes.locationInput}
              onMouseDown={handleLabelMouseDown}
              // style={{paddingLeft: isLocationHovered || isActivityHovered ? "36px" : "35px"}}
            >Wo?</span>
            <input
              type="text"
              className={`${classes.locationInput} semiboldSmall`}
              // style={{paddingLeft: isLocationHovered || isActivityHovered ? "36px" : "35px"}}
              placeholder="Standort auswählen"
              ref={inputRefs.location}
              onChange={(e) => handleChange('location', e)}
              onFocus={(e) => handleFocus('location', e)}
              onBlur={() => handleBlur('location')}
              value={searchFields.location}
            />
          </div>
          {/* <div 
            className={classes.smallLine} 
            style={{ display: isLocationHovered || isDateHovered ? 'none' : 'block' }}
          ></div> */}
        </div>
        {/* <div 
          style={{justifyContent: "flex-start"}}  
          className={`${classes.inputGroup} ${classes.dateInput}`} 
          onClick={() => handleClick('date')}
          onMouseEnter={handleDateMouseEnter}
          onMouseLeave={handleDateMouseLeave}
        >
          <div className={classes.searchText} style={{paddingLeft: "35px"}}>
            <span>Wann?</span>
            <input
              className='semiboldSmall'
              style={{width:"114px"}}
              type="text"
              onFocus={(e) => {
                e.target.type = 'date';
                handleFocus('date', e);
              }}
              onBlur={(e) => handleBlur('date', e)}
              placeholder="Datum auswählen"
              ref={inputRefs.date}
              onChange={(e) => handleChange('date', e)}
              value={searchFields.date || ''}
            />
          </div>
        </div> */}
        <div 
          onClick={handleSearchResults} 
          onMouseEnter={handleArrowMouseEnter}
          onMouseLeave={handleArrowMouseLeave}
          className={classes.arrowContainer}
        >
          <img src={arrow} alt="Go Icon"/>
        </div>
        <div className={`${classes.overlay}`} ref={overlayRef}></div>
      </div>
    </div>
  );
};

export default SearchInputs;
